import React from 'react';
import ReactDOM from 'react-dom';
import Root from './app/components/Root/Root';
import './i18n';

ReactDOM.render(
    <Root />,
    document.getElementById('root')
);
